angular.module("riskCourse.components", []).component("riskCourse", {
    templateUrl: "ng/components/riskCourse/riskCourse.view.html",
    bindings: {
        model: "=",
        snapshot: '<',
        enableNext: '&'
    },
    controllerAs: "riskCourseCtrl",
    controller: function RiskCourse($financialApiService, $timeout) {
        var self = this;

        self.$onInit = function () {
            console.log("self model riskCourse", self.model);
            jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
            self.isPending = true;
            if (self.snapshot) {
                $timeout(function () {
                    $financialApiService.getRischioInCorso(self.model.idWfInstance)
                        .then(function (response) {
                            self.preventiviAccettatiCustomer = response.rischioCliente.cliente.prevAccettati.numero
                            self.importoPreventiviAccettatiCustomer = response.rischioCliente.cliente.prevAccettati.importo
                            self.contrattiPervAttiviCustomer = response.rischioCliente.cliente.ctrAttivi.numero
                            self.importoContrattiPervAttiviCustomer = response.rischioCliente.cliente.ctrAttivi.importo;
                            self.contrattiStipulatiCustomer = response.rischioCliente.cliente.ctrStipulati.numero
                            self.importoContrattiStipulatiCustomer = response.rischioCliente.cliente.ctrStipulati.importo;
                            self.totaleCustomer = response.rischioCliente.cliente.totale.numero
                            self.importoTotaleCustomer = response.rischioCliente.cliente.totale.importo
                            self.preventiviAccettatiGroup = response.rischioCliente.gruppo.prevAccettati.numero
                            self.importoPreventiviAccettatiGroup = response.rischioCliente.gruppo.prevAccettati.importo
                            self.contrattiPervAttiviGroup = response.rischioCliente.gruppo.ctrAttivi.numero
                            self.importoContrattiPervAttiviGroup = response.rischioCliente.gruppo.ctrAttivi.importo;
                            self.contrattiStipulatiGroup = response.rischioCliente.gruppo.ctrStipulati.numero
                            self.importoContrattiStipulatiGroup = response.rischioCliente.gruppo.ctrStipulati.importo;
                            self.totaleGroup = response.rischioCliente.gruppo.totale.numero
                            self.importoTotaleGroup = response.rischioCliente.gruppo.totale.importo
                            self.totalePraticheCustomerGroup = response.rischioCliente.totGruppoCliente.totale.numero,
                                self.importoTotalePraticheCustomerGroup = response.rischioCliente.totGruppoCliente.totale.importo
                            self.exitNpl = response.rischioCliente.exitNpl;
                            self.model.leasingData.preventivo.uscitaNplRischio = self.exitNpl;
                            self.importoPrevAttuale = response.rischioCliente.cliente.prevAttuale.importo;
                            self.downloadKey = response.downloadKey;
                            Object.assign(self.model, {
                                exitNpl: self.exitNpl
                            });
                            self.isPending = false;
                        })
                        .catch(function (error) {
                            console.log("ERROR:", error);
                            self.isPending = false;
                        })
                }, 2000);
            } else {
                self.enableNext({ value: false });
                $financialApiService
                    .triggerStampaNsil(self.model.leasingData.preventivo.anno, self.model.leasingData.preventivo.numero, "RIC")
                    .then(function (response) {
                        $timeout(function () {
                            $financialApiService.getRischioInCorso(self.model.idWfInstance)
                                .then(function (response) {
                                    self.preventiviAccettatiCustomer = response.rischioCliente.cliente.prevAccettati.numero
                                    self.importoPreventiviAccettatiCustomer = response.rischioCliente.cliente.prevAccettati.importo
                                    self.contrattiPervAttiviCustomer = response.rischioCliente.cliente.ctrAttivi.numero
                                    self.importoContrattiPervAttiviCustomer = response.rischioCliente.cliente.ctrAttivi.importo;
                                    self.contrattiStipulatiCustomer = response.rischioCliente.cliente.ctrStipulati.numero
                                    self.importoContrattiStipulatiCustomer = response.rischioCliente.cliente.ctrStipulati.importo;
                                    self.totaleCustomer = response.rischioCliente.cliente.totale.numero
                                    self.importoTotaleCustomer = response.rischioCliente.cliente.totale.importo
                                    self.preventiviAccettatiGroup = response.rischioCliente.gruppo.prevAccettati.numero
                                    self.importoPreventiviAccettatiGroup = response.rischioCliente.gruppo.prevAccettati.importo
                                    self.contrattiPervAttiviGroup = response.rischioCliente.gruppo.ctrAttivi.numero
                                    self.importoContrattiPervAttiviGroup = response.rischioCliente.gruppo.ctrAttivi.importo;
                                    self.contrattiStipulatiGroup = response.rischioCliente.gruppo.ctrStipulati.numero
                                    self.importoContrattiStipulatiGroup = response.rischioCliente.gruppo.ctrStipulati.importo;
                                    self.totaleGroup = response.rischioCliente.gruppo.totale.numero
                                    self.importoTotaleGroup = response.rischioCliente.gruppo.totale.importo
                                    self.totalePraticheCustomerGroup = response.rischioCliente.totGruppoCliente.totale.numero,
                                        self.importoTotalePraticheCustomerGroup = response.rischioCliente.totGruppoCliente.totale.importo
                                    self.exitNpl = response.rischioCliente.exitNpl;
                                    self.model.leasingData.preventivo.uscitaNplRischio = self.exitNpl;
                                    self.importoPrevAttuale = response.rischioCliente.cliente.prevAttuale.importo;
                                    self.downloadKey = response.downloadKey;
                                    Object.assign(self.model, {
                                        exitNpl: self.exitNpl
                                    });
                                    self.isPending = false;
                                    self.enableNext({ value: true });
                                })
                                .catch(function (error) {
                                    console.log("ERROR:", error);
                                    self.isPending = false;
                                    self.enableNext({ value: true });
                                })
                        }, 2000);
                    })
                    .catch(function (error) {
                        console.log("ERROR:", error);
                        self.isPending = false;
                    })
            }
        };
    }
});